import { MessageCircle, BadgeCheck } from "lucide-react";
import { CONSULTANT, waLink } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const ConsultantCard = ({ racingBg }) => (
  <section className="relative overflow-hidden bg-xmove-night py-16 lg:py-24" data-testid="consultant-section">
    {racingBg && (
      <>
        <img src={racingBg} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-xmove-night via-xmove-night/85 to-xmove-night/50" />
      </>
    )}
    <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <div className="relative mx-auto max-w-sm lg:mx-0">
          <div className="absolute -inset-3 rounded-3xl border border-xmove-orange/30" />
          <img
            src={CONSULTANT.photo}
            alt={`${CONSULTANT.name}, consulente XMOVE Italia`}
            loading="lazy"
            className="aspect-[4/5] w-full rounded-2xl object-cover shadow-lift"
          />
          <span className="absolute -bottom-4 left-5 flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold text-xmove-ink shadow-lift">
            <BadgeCheck size={15} className="text-xmove-green" /> Il tuo referente diretto
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">Parla con chi guida davvero</p>
        <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-4xl">
          {CONSULTANT.name}
        </h2>
        <p className="mt-2 text-sm font-medium text-white/60">{CONSULTANT.role}</p>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-white/75">
          Niente call center e niente ticket: con XMOVE hai un consulente mobility che segue la tua
          pratica dalla prima telefonata alla consegna delle chiavi — e resta tuo referente per tutta
          la durata del contratto. Passione per i motori inclusa: siamo sponsor in Lamborghini Super Trofeo.
        </p>
        <a
          href={waLink(`Ciao ${CONSULTANT.name.split(" ")[0]}, ti scrivo dal sito XMOVE: vorrei un preventivo personalizzato.`)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="consultant-whatsapp-btn"
          className="mt-7 inline-flex items-center gap-2 rounded-xl bg-xmove-orange px-7 py-4 text-sm font-bold text-white shadow-lift transition-all hover:bg-xmove-orangeDark active:scale-[0.98]"
        >
          <MessageCircle size={17} />
          Scrivimi su WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
